<template>
  <v-row class="mb-8">
    <v-col class="mb-4"  cols="12" v-for="(sponsor) in sponsors" :key="sponsor.id">
      <v-row >
        <v-col cols="12" class="mt-4">
          <h3 v-if="!loading" class="font-weight-regular text-uppercase">{{ sponsor.name }}:</h3>
        </v-col>

        <v-col cols="12" xl="4" md="4" sm="12" v-for="(spo) in sponsor.sponsors" :key="spo.id">
          <cardSponsor v-if="!loading" :sponsor="spo"/>
        </v-col>
      </v-row>
    </v-col>
    
    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import cardSponsor from '@/components/card/cardSponsor'

  export default {
    name: 'sponsorsEdition',
    components:{cardSponsor},

    data: () => ({
      loading:true,
      sponsors:[],
    }),

    computed: {
      ...mapGetters([
        'edition'
      ])
    },

    methods:{
      async getSponsorsEdition(){
        await axios.get('participant/sponsors/'+this.edition.edition.id).then(response =>{
          this.sponsors = response.data.data.types_sponsors
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },
      handleEdition(){
        if(this.edition.edition.waiting_room){
          this.loading = false
          this.$router.push({ name: 'home' })
        }
      }
    },
    created(){
      Promise.all([
        this.handleEdition(),
        this.getSponsorsEdition()
      ]).then(() => {
        this.loading=false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
